


















import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GChatMessageMenu',
  props: {
    onClick: Function as PropType<Function>,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen;
    },
    onDelete() {
      this.onClick();
      this.toggleMenu();
    },
  },
});
